// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listview-header .loop-header-tools{padding:10px 0}.list-view-category-slider{width:calc(100% - 180px) !important}.list-view-category-slider [data-arrow=right]{position:absolute;right:0;top:2px;cursor:pointer;z-index:100}.list-view-category-slider [data-arrow=left]{position:absolute;left:0;top:2px;cursor:pointer;z-index:100}@media screen and (max-width: 767px){.list-view-category-slider{width:calc(100% - 80px) !important}}", ""]);
// Exports
module.exports = exports;
